import LazyComponent from '../core/components/router/LazyComponent';

const BrandPage = LazyComponent(async () => import('./components/BrandPage'));
const brandRoutes = [{ path: 'brands', element: <BrandPage /> }];

export default brandRoutes;
